import * as React from 'react';
import { IconProps } from './types';

export const ArrowLeftIcon: React.FC<IconProps> = ({
  size = '5',
  color = 'text-white',
  strokeWidth = 1.2,
  classNames = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`w-${size} h-${size} stroke-current ${color} ${classNames}`}
      viewBox="0 0 6 10"
      fill="none"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M5 9 1 5l4-4"
      />
    </svg>
  );
};
